require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-inclusive-education-tool.json") })
        }
      }, "path---en-us-update-inclusive-education-tool");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-inclusive-education-tool!./.cache/json/en-us-update-inclusive-education-tool.json
// module id = 759
// module chunks = 231608221292675